module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/azure/azure.component.scss
// module id = ./src/app/azure/azure.component.scss
// module chunks = main